import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: '[print-header]',
    templateUrl: './header.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintHeader {

    @Input()
    printButtonDisabled: boolean = false;

    @Output()
    notifyOpen: EventEmitter<boolean> = new EventEmitter();

    open(doOpen: boolean): void {
        this.notifyOpen.emit(doOpen);
    }

    doPrint(): void {
        const elemIdentifier = 'printDialogue';
        let printContents = document.getElementById(elemIdentifier).innerHTML;
        let popupWin = window.open('', '_blank', 'top=0,left=0,height=200,width=200');

        popupWin.moveTo(0, 0);
        popupWin.resizeTo(document.documentElement.clientWidth, document.documentElement.clientHeight);
        popupWin.document.open();

        // Wichtig: Der CSP-Header verhindert die Ausfuehrung von Inline-Skripten.
        // Bei Aenderungen muss der Hash von dem Skript in der Klasse SpringSecurityConfig angepasst werden!
        // Dazu einfach den Hash-Generator unter https://report-uri.com/home/hash verwenden und den Inhalt
        // zwischen den script-Tags verwenden. Umbrueche und Zeilenvorschuebe mussen mitkopiert werden, sonst
        // weicht der Hash-Wert von dem im Browser generierten ab.
        popupWin.document.write(`
        <html lang="de">
            <head>
                <title>VHV Kreditportal - Druckansicht</title>

                <link rel="stylesheet" href="/assets/css/fonts.css?t=1` + new Date().getTime() + `">
                <link rel="stylesheet" href="/assets/css/print4.css?t=1` + new Date().getTime() + `">
            </head>
            <body>
                ${printContents}
            </body>
            <script>document.body.onload = function() { window.print(); }</script>
        </html>`,
        );
        popupWin.document.close();
    }
}

